'use strict';

var React = require('react');

var SvgLogoBlockMajor = function SvgLogoBlockMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 2a1 1 0 0 1 1-1h2v2h-1v1h-2v-2zm18 0a1 1 0 0 0-1-1h-2v2h1v1h2v-2zm-17 17a1 1 0 0 1-1-1v-2h2v1h1v2h-2zm16 0a1 1 0 0 0 1-1v-2h-2v1h-1v2h2zm-12-2h3v2h-3v-2zm5 0h3v2h-3v-2zm3-16v2h-3v-2h3zm-5 0v2h-3v-2h3zm.598 5.332a4 4 0 0 0-3.573 7.147l3.573-7.147zm-1.598 7.668h8l-4-8-4 8z"
  }));
};

exports.SvgLogoBlockMajor = SvgLogoBlockMajor;
